import type { SVGProps } from 'react';

const SvgExclamationCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-1.41-1.41L10.59 12 8.59 10 10 8.59 12 10.59 14 8.59 15.41 10 13.41 12 15.41 14 14 15.41 12 13.41 10.59 12z"/>
  </svg>
);

export default SvgExclamationCircle;

